import { Championship } from "../types";

export default (championships: Championship[], championshipId: string): Championship | null => {
	if (championships === null) {
		return null;
	}
	return championships.find(championship => {
		return championship.uuid === championshipId;
	});
};
